import { default as ApiConstants } from 'shared/constants/ApiConstants.json';
import ApiUtils from 'shared/modules/ApiUtils';

const getCountriesAPI = () => ApiUtils.getRequest(ApiConstants.COUNTRIES_ENDPOINT);

export { getCountriesAPI };
